import {Component} from '@angular/core';
import {PercorsoVista} from '../contenitore-percorso/percorso-vista';

/** Feature 166, vista B: linea verticale con un nodo per fase, sottofasi affiancate. */
@Component({
  selector: 'app-contenitore-percorso-timeline',
  templateUrl: './contenitore-percorso-timeline.component.html',
  styleUrls: ['./contenitore-percorso-timeline.component.scss'],
  standalone: false
})
export class ContenitorePercorsoTimelineComponent extends PercorsoVista {}
